<template>
  <div>
    <v-overlay :value="loading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-row v-if="!loading">
      <v-col cols="12" class="py-1">
        <v-toolbar color="transparent" flat>
          <v-toolbar-title class="headline-header text-h6 px-0">{{ title }}</v-toolbar-title>
          <v-spacer />
          <v-btn depressed rounded color="green" dark :to="{ name: 'frota.competencia' }">
            <v-icon>mdi-arrow-left</v-icon>
            Voltar
          </v-btn>
        </v-toolbar>
      </v-col>
    </v-row>
    <v-divider class="pb-2 divider-header" />
    <v-card v-if="!loading" outlined>
      <v-card-title>
        Competência: <span class="ml-2">({{ data.mes }}/{{ data.ano }})</span>
      </v-card-title>
      <v-card-subtitle>
        <span v-if="data.data_abertura" class="green--text">
          <strong>Data Abertura:</strong> ({{ data.data_abertura | dateBR }})
        </span>
        <span v-if="data.data_fechamento" class="orange--text">
          | <strong> Data Fechamento:</strong> ({{ data.data_fechamento | dateBR }})
        </span>
      </v-card-subtitle>
      <v-divider></v-divider>
      <v-card-text>
        <v-list two-line>
          <v-list-item-group>
            <template v-for="(item, index) in listDates">
              <v-list-item
                :key="(index + 1) * 100"
                @click.stop="toggleFormItem(item)"
                :class="addBgClass(item)"
              >
                <template>
                  <v-list-item-content>
                    <v-list-item-title
                      :class="addTextClass(item)"
                      class="text--lighten-4 text-uppercase subtitle-1"
                    >
                      {{ item.data_dia | dateBR }} - {{ item.data_dia | dateStr }}
                    </v-list-item-title>

                    <v-list-item-subtitle
                      :class="addTextClass(item)"
                      class="text--lighten-5 font-weight-bold subtitle-2"
                    >
                      {{ item.evento.nome || '' }}
                    </v-list-item-subtitle>
                  </v-list-item-content>

                  <v-list-item-action>
                    <v-btn
                      fab
                      depressed
                      x-small
                      color="indigo lighten-4"
                      class="mr-2"
                      @click.stop="toggleFormItem(item)"
                    >
                      <v-icon small color="indigo">mdi-pencil</v-icon>
                    </v-btn>
                  </v-list-item-action>
                </template>
              </v-list-item>

              <v-divider v-if="index < data.dias.length - 1" :key="index"></v-divider>
            </template>
          </v-list-item-group>
        </v-list>
      </v-card-text>
    </v-card>
    <EventoModalForm />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import EventoModalForm from './evento/ModalForm.vue';

export default {
  name: 'CompetenciaShow',
  components: { EventoModalForm },
  metaInfo: {
    title: 'Detalhes da Competência',
    titleTemplate: `%s | ${process.env.VUE_APP_TITLE}`,
  },
  data: () => ({
    title: 'Detalhes da Competência',
    tab: null,
    loading: false,
  }),
  created() {
    this.loadCompetencia();
  },
  methods: {
    ...mapActions('competencia', ['find']),
    ...mapActions('dia', ['toggleFormItem']),
    addBgClass(item) {
      return {
        red: String(item.evento.nome).toUpperCase() === 'DIA NÃO ÚTIL',
        green: String(item.evento.nome).toUpperCase() === 'DIA ÚTIL',
        'deep-orange': String(item.evento.nome).toUpperCase() === 'FERIADO',
        brown: String(item.evento.nome).toUpperCase() === 'PONTO FACULTATIVO',
      };
    },
    addTextClass(item) {
      return {
        'red--text': String(item.evento.nome).toUpperCase() === 'DIA NÃO ÚTIL',
        'green--text': String(item.evento.nome).toUpperCase() === 'DIA ÚTIL',
        'deep-orange--text': String(item.evento.nome).toUpperCase() === 'FERIADO',
        'brown--text': String(item.evento.nome).toUpperCase() === 'PONTO FACULTATIVO',
      };
    },
    loadCompetencia() {
      this.loading = true;
      this.find({ id: this.$route.params.id }).finally(() => {
        this.loading = false;
      });
    },
  },
  computed: {
    ...mapState('competencia', ['data']),
    listDates() {
      const obj = this.data;
      if (obj.dias && obj.dias.length) {
        return obj.dias.sort((a, b) => new Date(a.data_dia) - new Date(b.data_dia));
      }
      return [];
    },
  },
};
</script>
